/**
 *
 * WithAppContainer
 *
 */

import React from 'react';
import AppContainer from 'components/AppContainer';
const withAppContainer = WrappedComponent => props => (
  <AppContainer>
    <WrappedComponent {...props} />
  </AppContainer>
);

export default withAppContainer;
